import React from "react";
import { Helmet } from "react-helmet";
import "../assets/css/style.css";
import dropp from "../assets/images/DROPP.png";
import playstore from "../assets/images/playstore.png";
import blog_1 from "../assets/images/blog1.png";
import blog_3 from "../assets/images/blog3.png";
import { Link } from "react-router-dom";

function Home() {
  return (
    <>
      <Helmet>
        <title>DROPP</title>
        <meta charSet="UTF-8" />
        <meta name="description" content="Free Web tutorials" />
        <meta name="keywords" content="HTML, CSS, JavaScript" />
        <meta name="author" content="John Doe" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        {/*------ Font family ------*/}
        <link
          href="https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap"
          rel="stylesheet"
        />
        {/*------ Font family ------*/}
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
          rel="stylesheet"
        />
        {/*------ Style Sheet ------*/}
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css"
          rel="stylesheet"
        />
        <link href="assets/css/style.css" rel="stylesheet" />
      </Helmet>
      {/*------ Header Start ------*/}
      <header>
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-6">
              <div className="header_main">
                <img src={dropp} className="w-100" alt="" />
              </div>
            </div>
            <div className="col-6 text-end">
              <div className="header_btn">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.app.dropp"
                  target="_blank"
                >
                  <img src={playstore} alt="" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/*------ Header End ------*/}
      {/*------ Blog-1 Start ------*/}
      <section className="blog1_details">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="blog1_details_main h-100 d-flex flex-column align-items-start justify-content-center">
                <h3 className="m-0">
                  Welcome to DROPP your Ultimate Shopping Companion!
                </h3>
                <p className="mt-4 mb-0">
                  We are thrilled to introduce you to an innovative way of
                  enhancing your retail experience. Whether you're a savvy
                  shopper or a dedicated brand enthusiast, our app is designed
                  to make your retail journey effortless, enjoyable, and
                  rewarding.
                </p>
                <p className="my-4">
                  The DROPP App is here to revolutionize your shopping
                  experience.
                </p>
                <Link
                  to="https://play.google.com/store/apps/details?id=com.app.dropp"
                  target="_blank"
                >
                  <img src={playstore} alt="" />
                </Link>
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0 col-12 d-flex align-items-center justify-content-center">
              <div className="blog1_img_main d-flex align-items-center justify-content-center w-100 h-100">
                <img src={blog_1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*------ Blog-1 End ------*/}
      {/*------ Blog-3 Start ------*/}
      <section className="blog3_details">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="blog3_details_main h-100 d-flex flex-column align-items-start justify-content-center">
                <h3 className="m-0 d-flex align-items-center">
                  Discover New Items
                </h3>
                <p className="mt-2 mb-4">
                  You'll love and stay updated with the latest trends and
                  exclusive offers. Create wishlists, save your favorite
                  products, and receive notifications when they go on sale.
                </p>
                <ul>
                  <li className="mb-4">
                    <h4>
                      <span className="svg_heading_icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width={30}
                          height={30}
                          x={0}
                          y={0}
                          viewBox="0 0 512 512"
                          style={{ enableBackground: "new 0 0 512 512" }}
                          xmlSpace="preserve"
                          className=""
                        >
                          <g>
                            <path
                              d="M406 271c-35.328 0-65.231 9.139-84.053 23.536l-144.126-35.788c-4.47-13.995-16.144-26.171-32.465-34.731l-18.398 27.618C117.568 264.262 104.106 271 90 271s-27.568-6.738-36.021-18.032l-19.325-28.956C13.705 234.998 0 251.851 0 271c0 33.137 40.294 60 90 60 40.206 0 73.85-17.695 85.397-41.949l127.323 31.586c-.95 3.371-1.719 6.79-1.719 10.364 0 12.482 6.136 23.795 16.681 33.193l-63.593 36.339C237.642 394.506 217.843 391 196 391c-59.854 0-106 25.796-106 60s46.146 61 106 61 105-26.796 105-61c0-12.482-6.136-23.795-16.681-33.193l63.593-36.339C364.358 387.494 384.157 391 406 391c59.854 0 106-25.796 106-60s-46.146-60-106-60z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                              className=""
                            />
                            <path
                              d="M78.003 234.994C80.83 238.773 85.283 241 90 241s9.17-2.227 11.997-6.006l60.044-91.044C173.789 128.291 180 109.644 180 90c0-49.629-40.371-90-90-90S0 40.371 0 90c0 19.629 6.211 38.291 17.959 53.95l60.044 91.044zM90 45c24.814 0 45 20.186 45 45s-20.186 45-45 45-45-20.186-45-45 20.186-45 45-45z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                              className=""
                            />
                          </g>
                        </svg>
                      </span>
                      Finding Way
                    </h4>
                    <p>
                      Finding your way to our physical stores has never been
                      easier with our integrated store locator feature. Get
                      directions, check store hours, and see real-time
                      availability of products in your nearest location.
                    </p>
                  </li>
                  <li>
                    <h4>
                      <span className="svg_heading_icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width={30}
                          height={30}
                          x={0}
                          y={0}
                          viewBox="0 0 512 512"
                          style={{ enableBackground: "new 0 0 512 512" }}
                          xmlSpace="preserve"
                        >
                          <g>
                            <path
                              d="M12.36 443.316c-2.594-2.597-2.493-7.27 1.144-10.902l21.492-21.496c13.707-13.703 30.941-18.066 48.387-.621l.52.52c17.445 17.44 12.874 35.3-1.454 49.632l-10.281 10.278 22.43 22.43c3.324 3.323.933 9.03-3.118 13.081-4.046 4.051-9.757 6.438-13.082 3.117zm25.44-6.957 21.91 21.91 10.278-10.28c5.817-5.813 6.024-12.669-1.039-19.727l-1.14-1.145c-7.059-7.058-13.914-6.851-19.73-1.039zM76.633 379.043c-2.594-2.598-2.91-6.852.101-9.863l21.496-21.492c14.227-14.227 30.84-20.25 47.762-3.325 11.63 11.63 12.98 23.57 8.516 33.64l35.617 10.282c1.04.207 1.867.832 2.387 1.352 4.05 4.047 3.011 13.808-1.766 18.586-2.074 2.074-4.879 3.215-8.203 2.18l-41.844-13.395-6.855 6.851 25.023 25.028c3.324 3.32.938 9.031-3.113 13.082-4.05 4.047-9.762 6.437-13.082 3.113zm25.437-6.957 19.317 19.312 10.277-10.277c5.816-5.816 6.957-11.734-.309-19.004-7.27-7.265-13.187-6.125-19.003-.308zM142.465 313.215c-3.426-3.43-.832-8.934 3.219-12.98 4.046-4.051 9.55-6.65 12.976-3.22l66.04 66.04c3.323 3.32.933 9.03-3.114 13.082-4.05 4.05-9.762 6.437-13.082 3.117zM221.379 328.578l-27.52-27.515c-17.855-17.86-13.39-35.614.938-49.946 14.328-14.328 32.187-18.894 50.047-1.035l27.515 27.516c17.86 17.859 13.29 35.718-1.039 50.047-14.328 14.332-32.082 18.793-49.941.933zm7.266-62.3c-7.165-7.165-13.915-6.852-19.727-1.036-5.816 5.813-6.023 12.461 1.14 19.625l27.516 27.516c7.164 7.164 13.813 6.957 19.625 1.14 5.817-5.812 6.13-12.562-1.039-19.726zM240.793 214.883c-2.598-2.598-2.906-6.856.105-9.863l21.493-21.497c14.226-14.222 30.84-20.246 47.761-3.32 11.633 11.629 12.98 23.57 8.516 33.64l35.617 10.282c1.04.207 1.867.828 2.387 1.352 4.05 4.046 3.012 13.808-1.766 18.582-2.074 2.078-4.879 3.218-8.203 2.183l-41.844-13.394-6.855 6.851 25.027 25.024c3.32 3.324.934 9.035-3.117 13.086-4.05 4.046-9.762 6.433-13.082 3.113zm25.441-6.957 19.313 19.312 10.277-10.277c5.817-5.816 6.957-11.734-.308-19.004-7.27-7.266-13.188-6.125-19.004-.309zM306.625 149.05c-3.426-3.425-.832-8.929 3.219-12.98 4.047-4.047 9.55-6.644 12.976-3.215l66.04 66.04c3.324 3.32.937 9.03-3.114 13.082-4.05 4.046-9.762 6.437-13.082 3.113zM379.309 66.61c3.425-3.426 8.617-1.145 12.043 2.28 3.945 3.95 5.609 9.141 2.492 12.255l-14.328 14.332 56.382 56.378c3.32 3.325.934 9.036-3.117 13.083-4.047 4.05-9.761 6.44-13.082 3.117l-56.383-56.383L348.988 126c-3.117 3.117-8.304 1.457-12.254-2.488-3.425-3.43-5.71-8.621-2.285-12.047zM457.598 78.031c-.621-.625-1.352-.933-1.868-1.039l-57.109-14.12c-.625-.208-1.039-.626-1.351-.935-3.84-3.843-.102-13.187 4.363-17.652 2.597-2.597 4.566-2.492 7.683-1.664l41.22 12.149-12.25-41.118c-.934-3.011-.934-5.09 1.66-7.683 4.464-4.465 13.812-8.203 17.652-4.36.312.313.726.727.933 1.348l14.227 57.008c.101.52.414 1.246 1.039 1.867l26.062 26.063c3.32 3.324.934 9.035-3.117 13.082-4.05 4.05-9.762 6.437-13.082 3.117zM256 91c-90.98 0-165 74.02-165 165 0 11.441 1.172 22.613 3.402 33.406L289.406 94.398A165.202 165.202 0 0 0 256 91zm0 0"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                            <path
                              d="M61 256c0-107.523 87.477-195 195-195 20.188 0 39.672 3.086 58 8.805l47.285-47.285C328.621 7.773 292.91 0 256 0 187.621 0 123.332 26.629 74.98 74.98 26.63 123.332 0 187.621 0 256c0 36.91 7.773 72.625 22.52 105.285L69.809 314C64.086 295.672 61 276.187 61 256zM256 421c90.98 0 165-74.02 165-165 0-5.41-.27-10.762-.781-16.04L239.96 420.22c5.277.511 10.629.781 16.039.781zm0 0"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                            <path
                              d="m495.352 164.828-48.965 48.965A194.987 194.987 0 0 1 451 256c0 107.523-87.477 195-195 195-14.488 0-28.61-1.602-42.207-4.613l-48.965 48.965C193.558 506.282 224.34 512 256 512c68.379 0 132.668-26.629 181.02-74.98C485.37 388.668 512 324.379 512 256c0-31.66-5.719-62.441-16.648-91.172zm0 0"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                          </g>
                        </svg>
                      </span>
                      Our Priority
                    </h4>
                    <p className="mb-0">
                      We understand the importance of convenience and security
                      in today's digital world. Our Retail Store App provides a
                      secure checkout process and multiple payment options. Your
                      information is protected, and your satisfaction is our
                      priority.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0 col-12 d-flex align-items-center justify-content-center">
              <div className="blog3_img_main d-flex align-items-center justify-content-center w-100 h-100">
                <img src={blog_3} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*------ Blog-3 End ------*/}
      {/*------ Footer End ------*/}
      <footer>
        <div className="container">
          <div className="row">
            <div className="footer_main">
              <ul>
                <li>
                  <Link to="terms-condition">Terms and conditions</Link>
                </li>
                <li>
                  <Link to="privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="return-policy">Return Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/*------ Footer End ------*/}
      {/*------ Java Script ------*/}
    </>
  );
}

export default Home;
